import { Link } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/faqs";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: { "@type": "Answer", text: f.answer },
  })),
};

export default function Faq() {
  usePageMeta(
    "香蕉动漫常见问题 - 资源合集使用指南",
    "香蕉动漫常见问题汇总，解答关于动漫资源合集浏览、更新频率、分类搜索与移动端体验等疑问，帮助你更顺畅地找番追番。",
    "/faq",
  );

  return (
    <main className="mx-auto max-w-5xl px-4 md:px-6 pt-24 pb-4">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <nav aria-label="面包屑" className="text-sm text-foreground-600">
        <ol className="flex items-center gap-1 flex-wrap">
          <li><a href="/" className="hover:text-primary-600">首页</a></li>
          <li aria-hidden="true"><i className="ri-arrow-right-s-line"></i></li>
          <li aria-current="page" className="text-foreground-950 font-medium">常见问题</li>
        </ol>
      </nav>

      <div className="mt-8 text-center">
        <p className="text-xs font-medium text-accent-600 tracking-wide">HELP CENTER</p>
        <h1 className="mt-1 font-heading text-3xl md:text-4xl text-foreground-950">常见问题</h1>
        <p className="mt-3 text-sm text-foreground-700 max-w-xl mx-auto leading-7">
          关于香蕉动漫资源合集的浏览、更新与使用方式，这里整理了大家最常遇到的问题与解答。
        </p>
      </div>

      <div className="mt-10 space-y-3">
        {faqs.map((f) => (
          <details
            key={f.id}
            className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden open:border-primary-300"
          >
            <summary className="flex items-center justify-between gap-3 px-5 md:px-6 py-5 cursor-pointer list-none text-sm md:text-base font-medium text-foreground-950">
              {f.question}
              <i
                className="ri-add-line text-foreground-500 group-open:rotate-45 transition-transform shrink-0"
                aria-hidden="true"
              ></i>
            </summary>
            <p className="px-5 md:px-6 pb-5 text-sm text-foreground-700 leading-7">{f.answer}</p>
          </details>
        ))}
      </div>

      <div className="mt-12 text-center bg-background-100/70 rounded-2xl py-10 px-6">
        <i className="ri-customer-service-2-line text-3xl text-primary-600" aria-hidden="true"></i>
        <h2 className="mt-3 font-heading text-lg text-foreground-950">还有疑问？</h2>
        <p className="mt-2 text-sm text-foreground-700">
          没有找到你想了解的内容？欢迎通过关于我们页面与我们联系。
        </p>
        <Link
          to="/about"
          className="mt-5 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-foreground-950 text-sm font-medium hover:bg-primary-400 transition-colors whitespace-nowrap"
        >
          联系我们 <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </main>
  );
}